"use strict";

exports.__esModule = true;
exports.default = constant;
// Predicate-generating function. Often useful outside of Underscore.
function constant(value) {
  return function () {
    return value;
  };
}